import React, { useMemo } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import configs from './config'
import WatchIcon from 'icon/watchicon'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

export default function LineChart({
  color,
  title,
  description,
  date,
  chart = {},
}) {
  const { data: chartData, options } = configs(
    chart.labels || [],
    chart.datasets || {}
  )


  return (
    <div class='border-gray-400 rounded-md shadow-xl p-6 bg-white'>
      <div className='h-full'>
        {useMemo(
          () => (
            <div
              className='bg-gradient-to-tr from-[#F35658] to-[#C7381D] shadow-sm h-52 -mt-12 rounded-lg pr-0.5 py-2'
              style={{ backgroundColor: color }}
            >
              <Line options={options} data={chartData} />
            </div>
          ),
          [chart, color]
        )}
      </div>
      <div class='mt-2'>
        <div>
          <h1 class='font-semibold text-lg'>{title}</h1>
          <p class=''>{description}</p>
        </div>
        <div className='x-divider !my-4' />

        <div class='flex'>
          <p class=' flex'>
            <div className='me-2'>
              <WatchIcon />
            </div>
            {date}
          </p>
        </div>
      </div>
    </div>
  )
}
